module.exports = __webpack_public_path__ + "static/img/pagelogo2.daa4f57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgCata/pagelogo2.png
// module id = LtaM
// module chunks = 47